import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {},
};

export const patioDoorOrder = createSlice({
  name: 'patioDoorOrder',
  initialState,
  reducers: {
    updateValue: (state, action) => {
      state.data[action.payload.id] = action.payload.value || '';
    },
    updateDataPatioDoor: (state, action) => {
      state.data = action.payload;
    },
    init: (state, action) => {
      state.data = initialState.data;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateValue, updateDataPatioDoor, init } =
  patioDoorOrder.actions;

export default patioDoorOrder.reducer;
